import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyFeedTypes, getDairyFeedTypesAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_DAIRY_FEED_TYPES } from "consts";

import { DairyFeedType } from "models";

export const useGetDairyFeedTypes = ({ enabled }: { enabled?: boolean } = {}) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("dairy", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((feedTypes: DairyFeedType[]) => injectNames(feedTypes, t, "feedTypes"), [t]);

  return useQuery({
    queryKey: [GET_DAIRY_FEED_TYPES, { enabled }, isAdmin],
    queryFn: () => (isAdmin ? getDairyFeedTypesAdmin({ enabled }) : getDairyFeedTypes({ enabled })),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
